import { NightDateTable } from '../../interfaces/night-date-table';

export class NightDateState {
  table!: NightDateTable;
  cheapestPrice!: number;
}
